/*
*###############################################################################
*Module Name                   : DPTextBoxWithButton.js                        #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Thursday, January 6th 2022, 3:34:04 pm        #
*Copyright (c) 2022 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/


import React, { useState } from 'react';
import { Row, Label, Input, Button } from "reactstrap"


const DPTextBoxWithButton = ({ rowClass, labelText, textType, value, onChange, placeholder, textAlign, disabled, onKeyPress, onBlur, id, onClickBtn }) => {

    return (
        <Row className={rowClass}>
            <div className="col-md-3">
                <Label htmlFor="example-text-input" className="col-form-label-sm">
                    {labelText}
                </Label>
            </div>
            <div className="col-md-9 d-flex align-items-center">
                <Input
                    className="form-control-sm flex-grow-1"
                    type={textType}
                    value={value}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    onBlur={onBlur}
                    onFocus={(e) => {
                        e.target.select();
                    }}
                    placeholder={placeholder}
                    style={{ textAlign: textAlign ? textAlign : 'left', textAlign: 'left', marginRight: '5px' }}
                    disabled={disabled}
                    id={id}
                />
                <Button
                    onClick={onClickBtn}
                    color="success"
                    className="btn-sm"
                    disabled={disabled}
                    style={{ height: '26px' }}
                >
                    <i className="mdi mdi-search-web" style={{ fontSize: "12px" }}></i>
                </Button>
            </div>
        </Row>


    );
}

export default DPTextBoxWithButton;